import { Avatar } from '@mui/material';
import { FormationSummary } from '@wwf/sdk';
import { useResource } from '@app/misc/useResource';
import { useRecordContext } from 'react-admin';

export const FormationCover = () => {
    const record = useRecordContext<FormationSummary>();
    const { data: src } = useResource(record?.cover?.id);

    return (
        <Avatar
            variant="rounded"
            src={src ?? undefined}
            alt={record?.name ?? 'Formation'}
            sx={{ width: 40, height: 40 }}
        >
            {(record?.name ?? '').charAt(0)}
        </Avatar>
    );
};
